import { motion } from "framer-motion";
import Seo from "../components/Seo";

const POSTS = [
  {
    title: "Cuaderno I — La tambora antes del amanecer",
    excerpt: "Notas y fotografías sin publicar de un viaje al sur de Bolívar.",
    date: "Próximamente",
    accent: "var(--magenta)",
  },
  {
    title: "Cuaderno II — Berlín en gris",
    excerpt: "Tres días, una cámara, ninguna agenda.",
    date: "Próximamente",
    accent: "var(--cyan)",
  },
  {
    title: "Cuaderno III — Las puloy de Montecristo",
    excerpt: "Volumen, ritual y resistencia.",
    date: "Próximamente",
    accent: "var(--tungsten)",
  },
];

export default function Diario() {
  return (
    <div data-testid="diario-page" className="pt-[18vh] sm:pt-[22vh] pb-[10vh]">
      <Seo
        title="Diario — Cuadernos de fotografía documental"
        description="Cuadernos de Emmanuel Upegui: notas y fotografías sin publicar. Reportajes de larga duración, viajes culturales y proyectos en proceso."
        path="/diario"
        keywords="diario fotográfico, cuaderno de viaje, fotografía documental, reportajes Emmanuel Upegui"
      />
      <header className="max-w-[1500px] mx-auto px-6 sm:px-12 md:pl-[10vw] lg:pl-[8vw]">
        <p className="text-[11px] tracking-[0.4em] uppercase font-display text-[var(--magenta)]">Diario</p>
        <h1 className="font-display uppercase font-bold tracking-tighter leading-[0.85] text-[16vw] sm:text-[12vw] lg:text-[10vw] mt-3">
          Cuadernos
        </h1>
        <p className="font-serif-accent text-xl sm:text-2xl text-white/70 mt-4 max-w-3xl font-light">
          Apuntes, ensayos cortos y fotografías inéditas. Una bitácora del oficio fotográfico.
        </p>
      </header>

      <section className="max-w-[1500px] mx-auto px-6 sm:px-12 md:pl-[10vw] lg:pl-[8vw] mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-10 pb-24">
        {POSTS.map((p, i) => (
          <motion.article
            key={i}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.7, delay: i * 0.08 }}
            data-testid={`diario-post-${i}`}
            className="border border-white/5 hover:border-white/20 p-8 transition-colors group"
          >
            <p className="text-[10px] tracking-[0.4em] uppercase font-display" style={{ color: p.accent }}>
              {p.date}
            </p>
            <h2 className="font-display uppercase font-medium tracking-tight text-2xl sm:text-3xl mt-4 leading-tight group-hover:text-white">
              {p.title}
            </h2>
            <p className="font-serif-accent text-white/70 mt-4 leading-relaxed">{p.excerpt}</p>
            <span className="mt-8 inline-block text-[11px] tracking-[0.3em] uppercase font-display text-white/30">
              Próximamente →
            </span>
          </motion.article>
        ))}
      </section>

      <section className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 pb-24 border-t border-white/5 pt-16 text-center">
        <p className="font-serif-accent text-2xl sm:text-3xl text-white/60 max-w-2xl mx-auto">
          "Lo que vale la pena fotografiar también vale la pena escribirlo."
        </p>
      </section>
    </div>
  );
}
